export default "__VITE_ASSET__RCvy1R8J__"